export let manifest = {};
export let esVersion = 2.4;
export const ManifestInit = themanifest => {
  Object.assign(manifest, themanifest);
  esVersion = manifest ? Number(manifest.EsVersion) : 2.4;
  return themanifest;
};
